import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationCreateLoginAnnouncement from '@/modules/client-setting/api/hooks/useMutationCreateLoginAnnouncement'
import { LoginAnnouncementQueryKeys } from '@/modules/client-setting/keys'
import LoginAnnounceForm, {
	LoginAnnounceFormValues,
	normalizeTargetPaths,
} from '../LoginAnnounceForm'

export default function CreateLoginAnnounceModal() {
	const [open, setOpen] = useState(false)
	const { mutate: createLoginAnnounce } = useMutationCreateLoginAnnouncement()
	const queryClient = useQueryClient()

	const onSubmit = (data: LoginAnnounceFormValues) => {
		const payload = {
			title: data.title,
			content: data.content || '',
			isActive: true,
			image: data.image,
			link: data.link || '',
			linkText: data.linkText || '',
			targetPaths: normalizeTargetPaths(data.targetPaths),
		}

		createLoginAnnounce(
			{ payload },
			{
				onSuccess: () => {
					toast.success('สร้างประกาศสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [LoginAnnouncementQueryKeys.GetLoginAnnouncement],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="default">เพิ่มประกาศ</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[800px]">
				<DialogHeader>
					<DialogTitle>เพิ่มประกาศ</DialogTitle>
				</DialogHeader>
				<LoginAnnounceForm onSubmit={onSubmit} submitButtonText="สร้างประกาศ" />
			</DialogContent>
		</Dialog>
	)
}
